module.exports = __webpack_public_path__ + "img/selling.ccd87406.jpg";